/**
 * Lightweight Google Analytics 4 + page-view tracking.
 *
 * Reads the Measurement ID from REACT_APP_GA4_MEASUREMENT_ID at build time.
 * If the env var is empty (or starts with "G-XXXX") analytics is silently skipped,
 * so development & preview builds don't fire spurious events.
 */
const MEASUREMENT_ID = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();

const isReal = (id) => /^G-[A-Z0-9]{6,}$/.test(id) && !id.startsWith("G-XXXX");

export function initAnalytics() {
  if (!isReal(MEASUREMENT_ID)) return;
  if (window.gtag) return; // already initialised

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID, { anonymize_ip: true });
}

export function trackPageView(path) {
  if (!isReal(MEASUREMENT_ID) || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!isReal(MEASUREMENT_ID) || !window.gtag) return;
  window.gtag("event", name, params);
}
